import React from 'react';

import './index.module.less';

import HalfScreenInfoModal from '@components/HalfScreenInfoModal';
import CommonBtn from '@components/CommonBtn';

interface IProps {
  uid: string;
  onClose: () => void;
  onDeleteClick: (uid: string) => void;
  onEditClick: (uid: string) => void;
}

const ClassDisableSelfMenu = (props: IProps) => {
  const onEditClick = () => {
    props.onClose && props.onClose();
    props.onEditClick && props.onEditClick(props.uid);
  }

  const onDeleteClick = () => {
    props.onClose && props.onClose();
    props.onDeleteClick && props.onDeleteClick(props.uid);
  }

  return (
    <HalfScreenInfoModal
      height="4.8rem"
      onClose={ props.onClose }
      hideCloseBtn={ true }
    >
      <div className='flex' styleName='menu-container'>
        <div className='flex' styleName='menu-item' onClick={onEditClick}>修改禁用时间</div>
        <div className='flex' styleName='menu-item' style={{color: '#E52E3D' }} onClick={onDeleteClick}>删 除</div>
      </div>
      <CommonBtn
        type="fixed"
        btnText="取 消"
        onConfirm={ props.onClose }
        style={{ background: '#F2F4F7', color: '#55585C', fontSize: '.32rem', marginBottom: '.48rem' }}
      />
    </HalfScreenInfoModal>
  )
}

export default ClassDisableSelfMenu;